import React, { useEffect, useState } from 'react';
import { useLocation, Link, Outlet } from 'react-router-dom';

// material-ui
import {Box, Button, Grid, Stack, Tab, Tabs} from '@mui/material';
import Container from '@mui/material/Container';
import { handlerSetXeroTenant, handlerSetTenantSelect, getUserStory, getUserStoryOrder, getProfiles, getComments, getItems, getColumns, getColumnsOrder } from '../../../store/reducer/kanban';

// project imports
import Loader from '../../../Components/Loader';
import {useDispatch, useSelector} from 'react-redux';
import useOAuth2 from "../../../OAuth2/OAuth2";
import AnimateButton from "../../../Components/@extended/AnimateButton";
import {LoginOutlined} from "@ant-design/icons";
import TenantListMenuItems from "../../../Components/TenantListMenuItems";
import XeroLoginButton from "../../../Components/XeroLoginButton";
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

// function XeroLoginButton(props){
//   let getAuth = props.getAuth;
//   return(
//       <>
//         <AnimateButton>
//           <Button size="large"
//                   onClick={() => getAuth()}
//                   endIcon={<LoginOutlined />}
//                   variant={"contained"}
//                   >Xero Sign In
//           </Button>
//         </AnimateButton>
//       </>
//   )
// }

export default function KanbanPage() {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  // const [tenant_select, setTenantSelect] = useState('');
  const [loading, setLoading] = useState(true);
  const tenant_select = useSelector((state) => {
    return state.kanban.selected_tenant
  });
  const xero_tenant = useSelector((state) => {
    return state.kanban.xero_tenant
  });
  console.log(xero_tenant);
  // const tenant_list = xero_tenant?.tenant_list;

  // const [{access_token, exp_time, refresh_token, tenantId, tenantName, tenant_list, xero_userid, exp}, setTokens] = useState({
  //       access_token: null,
  //       exp_time: null,
  //       refresh_token: null,
  //       tenantId: null,
  //       tenantName: null,
  //       tenant_list: null,
  //       xero_userid: null,
  //       exp: null
  //   });
  const { data, loading_xero, error, getAuth } = useOAuth2({
        authorizeUrl: "https://login.xero.com/identity/connect/authorize",
        clientId: process.env.REACT_APP_CLIENT_ID,
        // redirectUri: `${document.location.origin}/callback`,
        redirectUri: process.env.REACT_APP_redirectSignIn + `callback`,
          scope: "offline_access openid profile email accounting.invoices accounting.payments accounting.banktransactions accounting.manualjournals accounting.settings.read accounting.reports.read payroll.employees.read payroll.payruns.read payroll.payslip.read payroll.timesheets.read ",
        responseType: "code",
      });

  let selectedTab = 0;
  switch (pathname) {
    case '/apps/kanban/backlogs':
      selectedTab = 1;
      break;
    case '/apps/kanban/board':
    default:
      selectedTab = 0;
  }

  const [value, setValue] = useState(selectedTab);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeTenant = (event) => {
      const selectedTenantID = event.target.value.split('|')[0]
      const selectedTenantName = event.target.value.split('|')[1]
      console.log(selectedTenantID);
      console.log(selectedTenantName);
        // setTokens({
        //     tenantId: selectedTenantID,
        //     tenantName: selectedTenantName,
        //     access_token: access_token,
        //     exp_time: exp_time,
        //     refresh_token: refresh_token,
        //     tenant_list: tenant_list,
        //     xero_userid: xero_userid,
        //     exp: exp
        // })
      dispatch(handlerSetXeroTenant({
                xero_tenant:{
                          tenantId: selectedTenantID,
                          tenantName: selectedTenantName,
                          access_token: xero_tenant.access_token,
                          exp_time: xero_tenant.exp_time,
                          refresh_token: xero_tenant.refresh_token,
                          tenant_list: xero_tenant.tenant_list,
                          xero_userid: xero_tenant.xero_userid,
                          connections_list: xero_tenant.connections_list,
                          exp: xero_tenant.exp
                      }
              }));
      // setTenantSelect(event.target.value);
      dispatch(handlerSetTenantSelect({
        selected_tenant: event.target.value
      }));
      const items = dispatch(getItems(event.target.value));
        const columns = dispatch(getColumns(event.target.value));
        const columnOrder = dispatch(getColumnsOrder(event.target.value));
        const profile = dispatch(getProfiles(xero_tenant, event.target.value));
        const comments = dispatch(getComments(event.target.value));
        const story = dispatch(getUserStory(event.target.value));
        const storyOrder = dispatch(getUserStoryOrder(event.target.value));
        Promise.all([items, columns, columnOrder, profile, comments, story, storyOrder]).then(() => setLoading(false));
  }

  // useEffect(() => {
  //   // hide left drawer when email app opens
  //   dispatch(openDrawer(false));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);



  useEffect(() => {
  if (new Date(parseInt(xero_tenant['exp'])*1000+1800000)<=Date()){
      console.log("reset state")
        dispatch(handlerSetXeroTenant({
            xero_tenant: {}
        }))
        dispatch(handlerSetTenantSelect({
        selected_tenant: ""
      }));
    //     Set kanban state to initial state.
    }

    if (tenant_select){
        const items = dispatch(getItems(tenant_select));
        const columns = dispatch(getColumns(tenant_select));
        const columnOrder = dispatch(getColumnsOrder(tenant_select));
        const profile = dispatch(getProfiles(xero_tenant, tenant_select));
        const comments = dispatch(getComments(tenant_select));
        const story = dispatch(getUserStory(tenant_select));
        const storyOrder = dispatch(getUserStoryOrder(tenant_select));
        Promise.all([items, columns, columnOrder, profile, comments, story, storyOrder]).then(() => setLoading(false));
    } else {
        setLoading(false);
    }



    console.log(data);
    if (data.data != null){
          // if (!('defaultValue' in data.data)){
              console.log("Got");
              console.log(JSON.parse(JSON.stringify(data.data)));
              const result = JSON.parse(JSON.stringify(data.data));
              console.log(result);
              // console.log(JSON.parse(result));
              // setTokens({
              //     access_token: result['access_token'],
              //     exp_time: result['expires_in'],
              //     refresh_token: result['refresh_token'],
              //     tenant_list: result['connections_list'],
              //     tenantId: null,
              //     tenantName: null,
              //     xero_userid: result['xero_userid'],
              //     exp: result['exp']
              // });
              dispatch(handlerSetXeroTenant({
                xero_tenant:result
              }));
              return function clear_local_storage(){
                  localStorage.removeItem(process.env.REACT_APP_OAUTH_STATE_KEY);
              }
          }

    console.log(xero_tenant);


    }, [data]);

  if (loading) return <Loader />;

  if (error) {
        return <div>Error</div>;
    }
  if (loading_xero) {
      return <Loader />;
  }

  return (
      <>
      <Container maxWidth="lg" sx={{paddingTop: '10%'}}>
    <Box sx={{ display: 'flex' }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Tabs value={value} variant="scrollable" onChange={handleChange}>
            <Tab component={Link} to="/apps/kanban/board" label={value === 0 ? 'Board' : 'View as Board'} {...a11yProps(0)} />
            <Tab component={Link} to="/apps/kanban/backlogs" label={value === 1 ? 'Backlogs' : 'View as Backlog'} {...a11yProps(1)} />
          </Tabs>
        </Grid>
          {JSON.stringify(xero_tenant)=='{}' &&
            <>
                {/*<Grid item xs={12} lg={6}>*/}
                {/*    <XeroLoginButton getAuth={getAuth} />*/}
                {/*</Grid>*/}
            </>
          }

        {JSON.stringify(xero_tenant)!='{}' &&
            <>
          <Grid item xs={12} lg={6}>
            <TenantListMenuItems tenant_select={tenant_select} handleChangeTenant={handleChangeTenant} tenantList={xero_tenant.connections_list}/>
          </Grid>

        </>}
          {tenant_select!='' &&
          <>
          <Grid item xs={12}>
              <Outlet />
          </Grid>
          </>
          }



      </Grid>
    </Box>
      </Container>
        </>
  );
}